export function ensureHTTPS(value: string): string {
    if (typeof value !== 'string' || value.length <= 0) {
        return '';
    }
    const regx = /http:/g;
    return value.replace(regx, 'https:');
}

export function handleBackgroundURL(url: string): string {
    try {
        if (!url || typeof url !== 'string' || url.length <= 0) {
            return ''
        }

        if (checkWhiteSpace(url)) {
            const encoded_url = encodeURI(url)
            return typeof encoded_url === 'string' && encoded_url.length > 0 ? `url(${ensureHTTPS(encoded_url)})` : '';

        } else if (!checkWhiteSpace(url)) {
            return typeof url === 'string' && url.length > 0 ? `url(${ensureHTTPS(url)})` : '';
        }

        return ''
    } catch (err) {
        throw err
    }
}

export function validURL(url: string): boolean {
    const regx = /https:/g;
    return regx.test(url);
}

export function isImageURL(url: string): boolean {
    const supported_img_formats: string[] = ['.jpg', '.png', '.svg'];
    const supported = supported_img_formats.filter((f) => url === null ? false : url.includes(f));

    return supported.length > 0 ? true : false;
}

function checkWhiteSpace(url: string): boolean {
    return url.indexOf(' ') >= 0
}